module.exports = __webpack_public_path__ + "img/DE05920.1bc90631.png";